function celula(valor) {
  const texto = valor == null ? '' : String(valor);
  return `"${texto.replace(/"/g, '""')}"`;
}

function formatarData(valor, comHora) {
  if (!valor) return '';
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return '';
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dataCurta = `${dia}/${mes}/${data.getFullYear()}`;
  if (!comHora) return dataCurta;
  const hora = String(data.getHours()).padStart(2, '0');
  const minuto = String(data.getMinutes()).padStart(2, '0');
  return `${dataCurta} às ${hora}:${minuto}`;
}

function nomeArquivoExibicao(nome) {
  if (!nome) return '';
  let texto = String(nome);
  try {
    texto = decodeURIComponent(texto);
  } catch (erro) {
    texto = String(nome);
  }
  const barra = Math.max(texto.lastIndexOf('/'), texto.lastIndexOf('\\'));
  const trecho = barra >= 0 ? texto.slice(barra + 1) : texto;
  return trecho.replace(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i,
    ''
  );
}

const mensagemSemIdentificacao = 'Nenhuma identificação informada';

function texto(valor) {
  return valor == null ? '' : String(valor).trim();
}

function camposIdentificacao(item) {
  return [
    ['Tipo', texto(item.Tipo)],
    ['Número', texto(item.Numero)],
    ['Data do documento', formatarData(item.DataDocumento)],
  ]
    .filter(([, valor]) => valor)
    .map(([rotulo, valor]) => ({ rotulo, valor }));
}

function subtitulo(item) {
  const tipo = texto(item.Tipo);
  const numero = texto(item.Numero);
  return [texto(item.Modulo), tipo, numero && `Nº ${numero}`].filter(Boolean).join(' · ');
}

function formatarTamanho(bytes) {
  const tamanho = Number(bytes) || 0;
  if (tamanho < 1024) return `${tamanho} B`;
  if (tamanho < 1024 * 1024) return `${(tamanho / 1024).toFixed(1)} KB`;
  return `${(tamanho / (1024 * 1024)).toFixed(1)} MB`;
}

function baixarFicha(item) {
  const colunas = [
    'Módulo',
    'Título',
    'Tipo',
    'Número',
    'Data do documento',
    'Data da atualização',
    'Nome do arquivo',
    'Extensão',
    'Tamanho',
    'Data de inclusão',
    'Versão',
  ];
  const valores = [
    item.Modulo,
    item.Titulo,
    item.Tipo,
    item.Numero,
    formatarData(item.DataDocumento),
    formatarData(item.DataUltimaAtualizacao),
    nomeArquivoExibicao(item.NomeArquivo),
    item.Extensao,
    formatarTamanho(item.TamanhoBytes),
    formatarData(item.DataInclusao),
    item.NumeroVersao != null ? `v${item.NumeroVersao}` : '',
  ];
  const csv = `\uFEFF${colunas.map(celula).join(';')}\n${valores.map(celula).join(';')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${(nomeArquivoExibicao(item.NomeArquivo) || item.Titulo || 'documento').replace(/\.[^.]+$/, '')}-ficha.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export {
  formatarData,
  formatarTamanho,
  nomeArquivoExibicao,
  baixarFicha,
  camposIdentificacao,
  subtitulo,
  mensagemSemIdentificacao,
};
